import React from 'react';
import { bool, string, func } from 'prop-types';
import { connect } from 'react-redux';

import CustomModal from '~components/CustomModal';
import { INTERNAL_PAYMENT_MODAL, ORDER_CONFIRMATION_MODAL } from '~redux/Modal/constants';
import { FPAY_URL_TARGET, INGENICO_URL_TARGET } from '~redux/Orders/constants';
import { actionCreators as modalActions } from '~redux/Modal/actions';
import { actionCreators } from '~redux/Orders/actions';
import { HEIGHT, WIDTH } from '~screens/Dashboard/components/InternalPaymentModal/constants';

import styles from './styles.module.scss';

function InternalPaymentModal({
  isModalOpen,
  ingenicoURL,
  closeModal,
  fpayURL,
  checkoutButtonToggleLoading,
  cancelUrl
}) {
  const closeConfirmationModal = async () => {
    if (fpayURL) {
      await fetch(cancelUrl);
    }
    closeModal(ORDER_CONFIRMATION_MODAL);
    checkoutButtonToggleLoading(false);
  };

  const getClassModal = () => {
    if (fpayURL) {
      return styles.containerMini;
    }
    return styles.container;
  };
  return (
    <CustomModal
      className={`column center ${getClassModal()}`}
      modal={INTERNAL_PAYMENT_MODAL}
      isOpen={isModalOpen}
      shouldReturnFocusAfterClose={false}
      shouldCloseOnEsc={false}
      onClose={closeConfirmationModal}>
      {ingenicoURL && <iframe src={ingenicoURL} className={styles.iframe} />}
      {fpayURL && (
        <div className={styles.wrapMini}>
          <iframe src={fpayURL} className={styles.iframeMini} width={WIDTH} height={HEIGHT} />
        </div>
      )}
    </CustomModal>
  );
}

InternalPaymentModal.propTypes = {
  cancelUrl: string,
  checkoutButtonToggleLoading: func,
  closeModal: func,
  fpayURL: string,
  ingenicoURL: string,
  isModalOpen: bool
};

const mapDispatchToProps = dispatch => ({
  closeModal: modal => dispatch(modalActions.closeModal(modal)),
  checkoutButtonToggleLoading: value => dispatch(actionCreators.checkoutButtonToggleLoading(value))
});

const mapStateToProps = state => ({
  isModalOpen: state.modal[`${INTERNAL_PAYMENT_MODAL}ModalIsOpen`],
  ingenicoURL: state.order[INGENICO_URL_TARGET],
  fpayURL: state.order[FPAY_URL_TARGET],
  cancelUrl: state.order?.onlinePayment?.cancelUrl
});

export default connect(mapStateToProps, mapDispatchToProps)(InternalPaymentModal);
